import React, { useContext } from 'react';
import axios from "../../../../axios/index"
import { Link, useHistory } from 'react-router-dom';

// Context
import { UserContext } from '../../../Context/UserContextProvider';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Styles
import styles from "./../UserManagment.module.css";

// Images
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";

const UserManagmentChatCard = (props) => {
    const { userToken, userData } = useContext(UserContext);
    const history = useHistory()

    const userCardBox = (data) => {
        return (
            <div key={data.id} className={`position-relative d-flex align-items-center justify-content-start mt-3 mb-2 p-3 ${styles.total_user_managment_card_box}`}>
                <img className={`${styles.image_user_managment_card_box}`} src={`https://backdev.azrmelk.com/images/users/avatar/${data?.avatarName}`} loading="lazy" alt="user-profile" />

                <h5 className={`pe-3 mb-0 ${styles.title_user_managment_card_box}`}> {data.name + " " + data.family} </h5>
                <div className={`me-auto pointer ${styles.link_icon_text}`} onClick={() => createChat(data.id)}>
                    <img className='me-2' src={arrowBlue} alt="arrow-blue-icon" width="15" />
                </div>
            </div>
        )
    }

    const userLastChatsCard = (data) => {
        return (
            <div key={data.id} className={`position-relative d-flex align-items-center justify-content-start mt-3 mb-2 p-3 ${styles.total_user_managment_card_box}`}>

                {/* <i style={{ backgroundColor: "#127442" }} className={`position-absolute top-50 end-0 ${styles.status_user_managment_card_box}`}></i> */}

                {userData.id === data.senderId ?
                    <>
                        <img className={`${styles.image_user_managment_card_box}`} src={`https://backdev.azrmelk.com/images/users/avatar/${data.recieverAvatar}`} loading="lazy" alt="user-profile" />
                        <h5 className={`pe-3 mb-0 ${styles.title_user_managment_card_box}`}> {data.recieverFullName} </h5>
                        <Link to={{
                            pathname: `/user-managment-chat-detail/${data.id}`,
                            state: data
                        }} className={`me-auto ${styles.link_icon_text}`}>
                            <img className='me-2' src={arrowBlue} alt="arrow-blue-icon" width="15" />
                        </Link>
                    </>
                    :
                    <>
                        <img className={`${styles.image_user_managment_card_box}`} src={`https://backdev.azrmelk.com/images/users/avatar/${data.senderAvatar}`} loading="lazy" alt="user-profile" />
                        <h5 className={`pe-3 mb-0 ${styles.title_user_managment_card_box}`}> {data.senderFullName} </h5>
                        <Link to={{
                            pathname: `/user-managment-chat-detail/${data.id}`,
                            state: data
                        }} className={`me-auto ${styles.link_icon_text}`}>
                            <img className='me-2' src={arrowBlue} alt="arrow-blue-icon" width="15" />
                        </Link>
                    </>
                }
            </div>
        )
    }

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={9000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            <div dir="rtl" className={`text-right mx-4 px-2 pt-2 pb-3 mt-2 mb-3`} style={{ minHeight: "350px" }}>
                <div className={`d-flex align-items-start justify-content-md-between justify-content-center flex-wrap`}>
                    {props?.newClientUserChat == "" ?
                        <div className={`w-100 d-flex align-items-center justify-content-center mt-5 ${styles.notfound_text}`}>
                            هنوز هیچ موردی برای نمایش وجود ندارد
                        </div>
                        :
                        ""
                    }
                    {props?.userManagmentChatData == "" ?
                        <div className={`w-100 d-flex align-items-center justify-content-center mt-5 ${styles.notfound_text}`}>
                            هنوز هیچ موردی برای نمایش وجود ندارد
                        </div>
                        :
                        ""
                    }
                    {
                        props?.startNewChat
                            ? (
                                props?.newClientUserChat?.map(data => userCardBox(data))
                            ) : (
                                props?.userManagmentChatData?.map(data => userLastChatsCard(data))
                            )
                    }
                </div>
            </div>
        </>
    )

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    async function createChat(id) {
        try {
            // console.log(id)
            notify("درحال ایجاد چت", "success")
            var data = new FormData();
            data.append('RecieverId', id);
            data.append('Subject', "New Chat");
            const apiData = await axios.post(
                "Messages/CreateMessage",
                data,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            // console.log(apiData)
            if (apiData.data.isSuccess) {
                notify("درحال ایجاد چت", "success")
                history.push("/user-managment-chat")
            } else if (apiData.data.isSuccess === false) {
                notify("این چت قبلا برای شما ایجاد شده است", "error")
            }
        } catch (error) {
            notify("خطای سرور", "error")
            // console.log(error)
        }
    }


}

export default UserManagmentChatCard;
